import React, { useState } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Empty, Form, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, SafetyOutlined, ContactsOutlined, GlobalOutlined, InboxOutlined, ScheduleOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import Data from '../../../Data/Data.json';
import axios from "axios";
import Demand from '../../../Models/MTypepret';
import formatDate from "../../../Functions/Traitement/fomatDate";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import CheckStan from "../../Prints/CheckStan";
import RadioBox from "../../Radiox";
import SelectOption from "../../SelectOption";
import { Box, Typography } from '@mui/material';

let searchTYPEPRET: any = { CodeAgence: '', Table: "TYPEPRET", Colonne1: "TYPEPRET", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 };
let searchPlancp: any = { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 };
let searchCobac: any = { CodeAgence: '', Table: "REF_CATEGCOBAC", Colonne1: "CODE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 };
let searchDuree: any = { CodeAgence: '', Table: "TERME", Colonne1: "CODE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 };
let searchCompte: any = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22, colfiltre: 'TYPCPT', valfiltre: 'I' };
let searchBenef: any = { CodeAgence: '', Table: "REF_BENEFICIAIRE", Colonne1: "CODE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 };
let searchCodOpe: any = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 };

const fieldDesc: Record<string, string> = {
    TYPEPRET: 'Code unique du produit de prêt.',
    lib_TYPEPRET: 'Nom explicite du type de prêt.',
    mntMaxAuto: 'Plafond de montant pour une demande automatique.',
    nbrEchMax: 'Nombre maximal d\'échéances autorisé.',
    isModifTxInt: 'Autorise la modification du taux d\'intérêt en saisie.',
    isModifNbrEch: 'Autorise la modification du nombre d\'échéances.',
    isModifDatEch: 'Autorise la modification de la date d\'échéance.',
    ISRESDU: 'Base de calcul de la pénalité : restant dû ou montant d\'échéance.',
    tauxintmin: 'Taux d\'intérêt plancher applicable au produit.',
    TauxPenalite: 'Pourcentage de pénalité en cas de retard.',
    TAUXTAX: 'Taux de taxe appliqué sur les intérêts payés.',
    TVAIMPAIE: 'Taux de TVA appliqué sur les intérêts impayés.',
    MTNMINTAXABLE: 'Seuil minimum taxable pour la TVA/taxe.',
    txtProv: 'Taux de provision à constater sur créances douteuses.',
    ECARTECHPEN: 'Ecart autorisé entre la date d\'échéance et le calcul de pénalité.',
    NBJAVTIMP: 'Délai en jours avant de qualifier une échéance comme impayée.',
    PAYEMTAX: 'Active le paiement de la taxe.',
    ISTVAIMPAIE: 'Active la TVA sur les intérêts impayés.',
    GESIMPAI: 'Active la gestion automatique des impayés.',
    isGestCrDout: 'Active la gestion des créances douteuses.',
    JrConstatImp: 'Nombre de jours avant constat d\'impayé.',
    JrConstatDouteux: 'Nombre de jours avant constat de créance douteuse.',
    ISQUODITE: 'Active le calcul de quotidité sur les remboursements.',
    TAUXQUODITE: 'Taux de quotidité appliqué au remboursement.',
    ISPAIEPARG: 'Active le remboursement via épargne.',
    TAUXEPARG: 'Taux d\'épargne retenu sur chaque échéance.',
    MONTEPARG: 'Montant d\'épargne minimum ou fixe.',
    isbloqeparg: 'Bloque le produit si l\'épargne n\'est pas correcte.',
    isRembCptgrp: 'Autorise le remboursement par compte groupe.',
    ISFRAISSERVAMORT: 'Active les frais de service d\'amortissement.',
    isGestAssur: 'Active la gestion de l\'assurance sur le prêt.',
    txtAssur: 'Libellé/texte associé à l\'assurance.',
    fraiDosAssur: 'Frais de dossier d\'assurance.',
    txtEmf: 'Libellé/texte associé à l\'EMF.',
    tvaEmf: 'Taux de TVA applicable à l\'EMF.',
    CATEGCOBAC: 'Classification réglementaire COBAC/SESSEM du produit.',
    DUREE: 'Catégorie de durée : court, moyen, long terme ou découvert.',
    BENEFICIAIRE: 'Types de bénéficiaires autorisés pour ce prêt (sélection multiple).',
    PERSLIEE: 'Indique si le crédit concerne une personne liée.',
    RESTRUCTURE: 'Indique si le crédit est restructuré.',
    PLAFONDNDR: 'Montant maximum autorisé pour la concentration du risque (NDR).',
    IDPLENG: 'Plan comptable des engagements.',
    IDPLIMPAYE: 'Plan comptable des impayés client.',
    IDPLCRIMMO: 'Plan comptable des créances immobilisées client.',
    IDPLCRDOUT: 'Plan comptable des créances douteuses client.',
    IDPLINTIMP: 'Plan comptable des intérêts impayés client.',
    IDPLTVAIMP: 'Plan comptable de la TVA impayée client.',
    IDPLGARAN: 'Plan comptable des garanties client.',
    IDPLPROMESS: 'Plan comptable des promesses client.',
    IDPLINTDOUT: 'Plan comptable des intérêts hors bilan client.',
    IDPLPROV: 'Plan comptable des provisions client.',
    IDPLTVADOUT: 'Plan comptable de la TVA hors bilan client.',
    IDPLAGIOIMP: 'Plan comptable des agios impayés client.',
    IDPLPENIMP: 'Plan comptable des pénalités impayées client.',
    IDPLCPTINTIMP: 'Plan comptable interne des intérêts impayés.',
    IDPLCPTTVAIMP: 'Plan comptable interne de la TVA impayée.',
    IDPLCPTINTPAIE: 'Plan comptable interne des intérêts payés.',
    IDPLCPTCOMPTAX: 'Plan comptable interne de la taxe payée.',
    IDPLCPTCINTIMPA: 'Plan comptable interne du complément d\'intérêt impayé.',
    IDPLCPTPENIMP: 'Plan comptable interne des pénalités impayées.',
    IDPLCPTPENPAIE: 'Plan comptable interne des pénalités payées.',
    IDPLCPTPROMESS: 'Plan comptable interne des promesses.',
    IDPLCPTGARAN: 'Plan comptable interne des garanties.',
    IDPLCPTINTDOUT: 'Plan comptable interne des intérêts hors bilan.',
    IDPLCPTTVADOUT: 'Plan comptable interne de la TVA hors bilan.',
    IDPLCPTPROVCRDOUT: 'Plan comptable interne de la dotation provision.',
    IDPLCPTCRDOUT: 'Plan comptable interne des créances douteuses.',
    IDPLCPTCRIMMO: 'Plan comptable interne des créances immobilisées.'
};

const Typepret = () => {
    const auth = useAuthUser();
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()));
    const authHeader = useAuthHeader();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("");
    const [Idbutton, setIdbutton] = useState(false);
    const [Idbutton2, setIdbutton2] = useState(true);
    const [Activetabs, SetActivetabs] = useState(false);
    const [termePlans, setTermePlans] = useState<any | null>(null);
    const duree = Form.useWatch('DUREE', form);

    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false);
        setIdbutton(true);
        SetActivetabs(true);
        setIdbutton2(true);
    }

    function HandleAjout() {
        form.resetFields();
        setTermePlans(null);
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add');
        setIdbutton2(false);
    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('modif');
        setSupprime(true);
        SetActivetabs(false);
        setIdbutton2(false);
    }

    function HandleSupp() {
        setSbmit('supp');
    }

    function HandleAnnul() {
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setTermePlans(null);
        setFormactve(true);
        setSbmit('');
        setIdbutton(false);
        SetActivetabs(false);
        setIdbutton2(true);
    }

    // Helpers de rendu - layout vertical : label au-dessus du champ
    const I = (label: string, name: string, type: any = 'text', money?: boolean, def?: any) =>
        <InputForm width={24} label={label} type={type} name={name} money={money} defaultValue={def} notRequired />;

    const C = (label: string, name: string, def?: boolean) =>
        <CheckStan width={24} label={label} name={name} CheCkDefauld={def ?? false} />;

    const Plan = (label: string, name: string) =>
        <SearchModal width={24} Titre="" Parametre={searchPlancp} label={label} name={name} Taille1="40%" Taille2="60%" form={form} />;

    const Cpt = (label: string, name: string) =>
        <SearchModal width={24} Titre="" Parametre={searchCompte} label={label} name={name} Taille1="40%" Taille2="60%" form={form} />;

    const Ope = (label: string, name: string) =>
        <SearchModal width={24} Titre="" Parametre={searchCodOpe} label={label} name={name} Taille1="40%" Taille2="60%" form={form} />;

    const Sel = (label: string, name: string, parametre: any, multiple = false) =>
        <SelectOption width={24} label={label} name={name} Parametre={parametre} notRequired multiple={multiple} />;

    const Guide = (text: string) => (
        <Typography variant="caption" sx={{ display: 'block', mb: 2, color: '#555' }}>
            {text}
        </Typography>
    );

    const Field = (children: any) => {
        const name = children?.props?.name;
        const desc = name ? fieldDesc[name] : undefined;
        const label = children?.props?.label;
        const notRequired = children?.props?.notRequired;

        if (!label) {
            return (
                <Box title={desc} sx={{ minWidth: 0, width: '100%' }}>
                    {children}
                </Box>
            );
        }

        const child = React.cloneElement(children, { label: undefined, width: 0 });
        return (
            <Box title={desc} sx={{ display: 'grid', gridTemplateColumns: '35% minmax(0, 1fr)', gap: 1, alignItems: 'center', minWidth: 0}}>
                <Box sx={{ textAlign: 'left', pr: 1, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {!notRequired && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}
                    {label}
                </Box>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                    {child}
                </Box>
            </Box>
        );
    };

    const Full = (children: any) => (
        <Box sx={{ gridColumn: 'span 2', mb: 1 }}>{children}</Box>
    );

    const tabPanel = (title: string, guide: string, content: any) => (
        <div className='tabItem' style={{ display: 'block', width: '100%' }}>
            <fieldset className="bordure1" style={{ marginBottom: 12, width: '100%' }}>
                <legend style={{ fontSize: '15px', padding: '0 10px', color: '#116599' }}>{title}</legend>
                {Guide(guide)}
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 1.5 }}>
                    {content}
                </Box>
            </fieldset>
        </div>
    );

    const items: TabsProps['items'] = [
        {
            key: '1',
            forceRender: true,
            label: (<span><UserOutlined /> Identification</span>),
            children: tabPanel("Identification et contrôle",
                "Saisissez le code, le libellé et les autorisations de modification du type de prêt.",
                <>
                    {Field(<SearInputG
                        width={0}
                        dissabledLib={Idbutton2}
                        dissabledCode={Idbutton}
                        notremove
                        Titre="Recherche"
                        label="Type prêt"
                        name="TYPEPRET"
                        Taille1="100%"
                        Taille2="100%"
                        Parametre={searchTYPEPRET}
                        form={form}
                    />)}
                    {Field(I("Libellé", "lib_TYPEPRET"))}
                    {Field(I("Montant max autorisé", "mntMaxAuto", "number", false, 0))}
                    {Field(I("Nombre échéance max", "nbrEchMax", "number", false, 0))}
                    {Field(C("Modifier taux d'intérêt", "isModifTxInt", false))}
                    {Field(C("Modifier nombre d'échéances", "isModifNbrEch", false))}
                    {Field(C("Modifier date d'échéance", "isModifDatEch", false))}
                    {Field(<RadioBox
                        width={24}
                        defaultValue="false"
                        LibValue1="Pénalité sur restant dû"
                        Value1="false"
                        Value2="true"
                        libVlue2="Pénalité sur montant échéance"
                        name="ISRESDU"
                    />)}
                </>)
        },
        {
            key: '5',
            forceRender: true,
            label: (<span><GlobalOutlined /> Réglementaire</span>),
            children: tabPanel("Hors-bilan et classification COBAC/SESSEM",
                "Sélectionnez le Terme associé et renseignez les contrôles NDR.",
                <>
                    {Field(Sel("Terme", "DUREE", searchDuree))}
                    {Field(Sel("Bénéficiaires autorisés", "BENEFICIAIRE", searchBenef, true))}
                    {Field(C("Personne liée", "PERSLIEE", false))}
                    {Field(C("Crédit restructuré", "RESTRUCTURE", false))}
                    {Field(I("Plafond NDR", "PLAFONDNDR", "number", false, 0))}
                </>)
        },
        {
            key: '2',
            forceRender: true,
            label: (<span><SafetyOutlined /> Taux & fiscalité</span>),
            children: tabPanel("Paramètres financiers",
                "Renseignez les taux et seuils utilisés pour les intérêts, pénalités, taxes et TVA.",
                <>
                    {Field(I("Taux intérêt minimum", "tauxintmin", "number", true, 0))}
                    {Field(I("Taux pénalité", "TauxPenalite", "number", true, 0))}
                    {Field(I("Taux taxe payée", "TAUXTAX", "number", true, 0))}
                    {Field(I("Taux TVA impayé", "TVAIMPAIE", "number", true, 0))}
                    {Field(I("Montant minimum taxable", "MTNMINTAXABLE", "number", false, 0))}
                    {Field(I("Taux provision", "txtProv", "number", true, 0))}
                    {Field(I("Ecart échéance / pénalité", "ECARTECHPEN", "number", false, 0))}
                    {Field(I("Nbre jours avant impayé", "NBJAVTIMP", "number", false, 0))}
                    {Field(C("Paiement taxe", "PAYEMTAX", false))}
                    {Field(C("TVA impayée", "ISTVAIMPAIE", false))}
                </>)
        },
        {
            key: '3',
            forceRender: true,
            label: (<span><SafetyOutlined /> Options & services</span>),
            children: tabPanel("Quotidité, épargne, impayés et services",
                "Définissez les options de remboursement, les règles de provision et les services.",
                <>
                    {Field(C("Gestion impayé", "GESIMPAI", false))}
                    {Field(C("Gestion créance douteuse", "isGestCrDout", false))}
                    {Field(I("Jours constat créance impayée", "JrConstatImp", "number", false, 0))}
                    {Field(I("Jours constat créance douteuse", "JrConstatDouteux", "number", false, 0))}
                    {Field(C("Quotidité", "ISQUODITE", false))}
                    {Field(I("Taux quotidité", "TAUXQUODITE", "number", true, 0))}
                    {Field(C("Paiement épargne", "ISPAIEPARG", false))}
                    {Field(I("Taux épargne", "TAUXEPARG", "number", true, 0))}
                    {Field(I("Montant épargne", "MONTEPARG", "number", false, 0))}
                    {Field(C("Bloquer épargne", "isbloqeparg", false))}
                    {Field(C("Remboursement compte groupe", "isRembCptgrp", false))}
                    {Field(C("Frais service amortissement", "ISFRAISSERVAMORT", false))}
                    {Field(C("Gestion assurance", "isGestAssur", false))}
                    {Field(I("Texte assurance", "txtAssur", "text", false, ''))}
                    {Field(I("Frais dossier assurance", "fraiDosAssur", "text", false, ''))}
                    {Field(I("Texte EMF", "txtEmf", "text", false, ''))}
                    {Field(I("TVA EMF", "tvaEmf", "number", false, 0))}
                </>)
        },
        {
            key: '7',
            forceRender: true,
            label: (<span><ScheduleOutlined /> Rééchelonnement</span>),
            children: tabPanel("Conditions de rééchelonnement",
                "Politique de rééchelonnement du produit : autorisation, limites, capitalisation et frais.",
                <>
                    {Field(C("Rééchelonnable", "isReechelonnable", false))}
                    {Field(I("Nb rééchelonnements max", "nbrReechMax", "number", false, 0))}
                    {Field(I("Délai min. entre rééchelonnements (mois)", "delaiMinReech", "number", false, 0))}
                    {Field(I("Nb min. échéances payées", "nbMinEchPayees", "number", false, 0))}
                    {Field(C("Capitaliser les intérêts impayés", "isCapitaliserInt", false))}
                    {Field(C("Capitaliser les pénalités impayées", "isCapitaliserPen", false))}
                    {Field(Ope("Frais rééchelonnement (code opération)", "CODOPE_REECH"))}
                </>)
        },
        {
            key: '8',
            forceRender: true,
            label: (<span><ScheduleOutlined /> Restructuration</span>),
            children: tabPanel("Conditions de restructuration",
                "Politique de restructuration du produit : autorisation, limites, renégociation, frais et période probatoire COBAC.",
                <>
                    {Field(C("Restructurable", "RESTRUCTURE", false))}
                    {Field(I("Nb restructurations max", "nbrRestruMax", "number", false, 0))}
                    {Field(I("Délai min. entre restructurations (mois)", "delaiMinRestru", "number", false, 0))}
                    {Field(I("Nb min. échéances payées", "nbMinRestruPayees", "number", false, 0))}
                    {Field(C("Capitaliser les intérêts impayés", "isRestruInt", false))}
                    {Field(C("Capitaliser les pénalités impayées", "isRestruPen", false))}
                    {Field(C("Taux renégociable", "isRestruTaux", false))}
                    {Field(I("Taux max. restructuré (%)", "tauxRestruMax", "number", false, 0))}
                    {Field(C("Type amortissement modifiable", "isRestruTypamort", false))}
                    {Field(Ope("Frais restructuration (code opération)", "CODOPE_RESTRU"))}
                    {Field(I("Période probatoire (jours)", "delaiProbatoire", "number", false, 180))}
                    {Field(I("Taux fonds propres min (%)", "txFondsPro", "number", false, 20))}
                </>)
        },
        {
            key: '4',
            forceRender: true,
            label: (<span><ContactsOutlined /> Comptes</span>),
            children: tabPanel("Plans comptables",
                "Sélectionnez les plans comptables client et internes. Les comptes agence seront générés automatiquement.",
                Full(
                    <Tabs defaultActiveKey="client" tabPosition="left" size="small" type="card" className="csal-comptes-tabs" style={{ width: '100%' }} items={[
                        {
                            key: 'client',
                            label: 'Comptes client',
                            children: (
                                <Box sx={{ p: 1 }}>
                                    {!duree ? (
                                        <Empty image={<InboxOutlined style={{ fontSize: 40, color: '#116599' }} />} description="Sélectionnez un Terme dans l'onglet Réglementaire" />
                                    ) : (
                                        <Box sx={{ border: '1px solid #116599', borderRadius: 2, bgcolor: '#f5f9fc', p: 1.5 }}>
                                            <Typography variant="subtitle2" sx={{ color: '#0d4a70', mb: 1 }}>
                                                Comptes client — hérités du Terme {duree}
                                            </Typography>
                                            {termePlans === null ? (
                                                <Empty image={<InboxOutlined style={{ fontSize: 40, color: '#116599' }} />} description="Aucun plan comptable disponible pour ce Terme" />
                                            ) : (
                                                (() => {
                                                    const plans = [
                                                        ['Engagement', 'PLENG'],
                                                        ['Impayé', 'PLIMPAYE'],
                                                        ['Créance immobilisée', 'PLCRIMMO'],
                                                        ['Créance douteuse', 'PLCRDOUT'],
                                                        ['Intérêt impayé', 'PLINTIMP'],
                                                        ['TVA impayé', 'PLTVAIMP'],
                                                        ['Garantie', 'PLGARAN'],
                                                        ['Promesse', 'PLPROMESS'],
                                                        ['Intérêt hors bilan', 'PLINTDOUT'],
                                                        ['Provision', 'PLPROV'],
                                                        ['TVA hors bilan', 'PLTVADOUT'],
                                                        ['Agio impayé', 'PLAGIOIMP'],
                                                        ['Pénalité impayé', 'PLPENIMP'],
                                                    ];
                                                    const hasAny = plans.some(([, plName]) => termePlans[plName]);
                                                    return hasAny ? (
                                                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 1.5 }}>
                                                            {plans.map(([lib, plName]) => {
                                                                const pl = termePlans[plName];
                                                                const plLib = termePlans[plName + '_LIB'];
                                                                return (
                                                                    <Box key={lib} sx={{ bgcolor: '#fff', border: '1px solid #e0eef8', borderRadius: 1, p: 1, display: 'grid', gridTemplateColumns: '42% 1fr', gap: 1, alignItems: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
                                                                        <Typography variant="caption" sx={{ color: '#0d4a70', fontWeight: 500 }}>{lib}</Typography>
                                                                        <Typography variant="body2" sx={{ fontFamily: 'monospace', color: '#116599', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                            {pl ? `${pl} — ${plLib ?? ''}` : '—'}
                                                                        </Typography>
                                                                    </Box>
                                                                );
                                                            })}
                                                        </Box>
                                                    ) : (
                                                        <Empty image={<InboxOutlined style={{ fontSize: 40, color: '#116599' }} />} description="Aucun plan comptable client pour ce Terme" />
                                                    );
                                                })()
                                            )}
                                        </Box>
                                    )}
                                </Box>
                            )
                        },
                        {
                            key: 'interne',
                            label: 'Comptes internes',
                            children: (
                                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 1.5, p: 1 }}>
                                    {Field(Cpt("Intérêt impayé", "IDPLCPTINTIMP"))}
                                    {Field(Cpt("TVA impayé", "IDPLCPTTVAIMP"))}
                                    {Field(Cpt("Intérêt payé", "IDPLCPTINTPAIE"))}
                                    {Field(Cpt("Taxe payée", "IDPLCPTCOMPTAX"))}
                                    {Field(Cpt("Complément intérêt impayé", "IDPLCPTCINTIMPA"))}
                                    {Field(Cpt("Pénalité impayé", "IDPLCPTPENIMP"))}
                                    {Field(Cpt("Pénalité payée", "IDPLCPTPENPAIE"))}
                                    {Field(Cpt("Promesse octroi", "IDPLCPTPROMESS"))}
                                    {Field(Cpt("Garantie interne", "IDPLCPTGARAN"))}
                                    {Field(Cpt("Intérêt hors bilan", "IDPLCPTINTDOUT"))}
                                    {Field(Cpt("TVA hors bilan", "IDPLCPTTVADOUT"))}
                                    {Field(Cpt("Dotation provision créance douteuse", "IDPLCPTPROVCRDOUT"))}
                                    {Field(Cpt("Créance douteuse", "IDPLCPTCRDOUT"))}
                                    {Field(Cpt("Créance immobilisée", "IDPLCPTCRIMMO"))}
                                </Box>
                            )
                        }
                    ]} />
                )
            )
        }
    ];

    // Champs masqués conservés pour compatibilité avec le SP (valeurs par défaut)
    const hiddenFields = (
        <Box sx={{ display: 'none' }}>
            {I("", "COCREAIM", "text", false, '')}
            {I("", "INTREIMP", "text", false, '')}
            {I("", "CINTIMPA", "text", false, '')}
            {I("", "COPENRET", "text", false, '')}
            {I("", "CINTPAIE", "text", false, '')}
            {I("", "COMPTAX", "text", false, '')}
            {I("", "CPTTVAIMP", "text", false, '')}
            {I("", "PLANCP1", "text", false, '')}
            {I("", "PLANCP2", "text", false, '')}
            {I("", "PLANCP3", "text", false, '')}
            {I("", "PLANCP4", "text", false, '')}
            {I("", "NUMCPTQUOD", "text", false, '')}
            {I("", "cptCrDout", "text", false, '')}
            {I("", "cptProvCrImp", "text", false, '')}
            {I("", "cptDotProv", "text", false, '')}
            {I("", "cptDotProvDout", "text", false, '')}
            {I("", "cptProvCrDout", "text", false, '')}
            {I("", "cptIntCrDout", "text", false, '')}
            {I("", "cptCplIntCrDout", "text", false, '')}
            {I("", "cptImoCrDout", "text", false, '')}
            {I("", "cptDotProvCrDout", "text", false, '')}
            {I("", "cptPenARecev", "text", false, '')}
            {I("", "cptAssur", "text", false, '')}
            {I("", "cptEmf", "text", false, '')}
            {I("", "cpttvaEmf", "text", false, '')}
            {I("", "cptEng", "text", false, '')}
            {I("", "cptPromessOctPret", "text", false, '')}
            {I("", "CHOICE", "number", false, 0)}
            {I("", "typPaieFrSrv", "number", false, 0)}
            {C("", "isbloqte", false)}
            {C("", "ishistse", false)}
            {I("", "IDPLENG", "text", false, '')}
            {I("", "IDPLIMPAYE", "text", false, '')}
            {I("", "IDPLCRIMMO", "text", false, '')}
            {I("", "IDPLCRDOUT", "text", false, '')}
            {I("", "IDPLINTIMP", "text", false, '')}
            {I("", "IDPLTVAIMP", "text", false, '')}
            {I("", "IDPLGARAN", "text", false, '')}
            {I("", "IDPLPROMESS", "text", false, '')}
            {I("", "IDPLINTDOUT", "text", false, '')}
            {I("", "IDPLPROV", "text", false, '')}
            {I("", "IDPLTVADOUT", "text", false, '')}
            {I("", "IDPLAGIOIMP", "text", false, '')}
            {I("", "IDPLPENIMP", "text", false, '')}
            {I("", "CATEGCOBAC", "text", false, '')}
        </Box>
    );

    // Charge les plans comptables client du Terme associe (lecture seule)
    function loadTerme(code: string) {
        setTermePlans(null);
        if (!code) return;
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.ReadTerme,
            headers: {
                'CypherTerme': code + '|' + Perss.codage,
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
            },
        };
        axios.request(config)
            .then((response) => {
                if (response.data) {
                    const res = JSON.parse(Crypter.decrypt(response.data));
                    if (res.StatutCode == 200) {
                        setTermePlans(res.Result.Table[0]);
                    }
                    else {
                        setTermePlans(null);
                    }
                }
            })
            .catch(() => setTermePlans(null));
    }

    function consult() {
        if (form.getFieldValue("TYPEPRET") == null) {
            SweetAlert.fire({ title: "Svp renseigner le Id Type Prêt", icon: "warning" });
        } else {
            let data = (form.getFieldValue("TYPEPRET"));
            HandleConsult();
            if (data.length != 0) {
                setLoading(true);
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadTypepret,
                    headers: {
                        'CypherTypepret': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            let DemandVP = res.Result.Table[0];

                            if (res.StatutCode == 200) {
                                form.setFieldsValue(DemandVP);
                                form.setFieldValue("lib_TYPEPRET", DemandVP.LIBELLE);
                                form.setFieldValue("ISRESDU", DemandVP.ISRESDU ? "true" : "false");
                                loadTerme(DemandVP.DUREE);
                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" });
                            }
                        }
                        setLoading(false);
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error);
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" });
                    });
            }
        }
    }

    const onFinish = (values: any) => {
        var Demand: Demand = values;
        Demand.LIBELLE = form.getFieldValue("lib_TYPEPRET");
        Demand.DATCRE = formatDate(Perss.datjour);
        Demand.codage = (Perss.codage);
        Demand.UTILIS = Perss.coduti;
        Demand.ISRESDU = (form.getFieldValue("ISRESDU") === "true");

        if (sbmit == "add") {
            SweetAlert.fire({
                title: "Création d'un Type Prêt",
                text: "Voulez-vous Créer ce Type Prêt ",
                showCancelButton: true,
                confirmButtonText: "Oui",
                cancelButtonText: "Non",
                icon: "question"
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true);
                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateTypepret,
                        headers: {
                            'CypherTypepret': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        }
                    };
                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode == 200) {
                                    SweetAlert.fire({ title: "Succès", text: res.Message, icon: "success" });
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" });
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error);
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" });
                        });
                }
            });
        }

        if (sbmit == "modif") {
            SweetAlert.fire({
                title: "M.A.J d'un Type Prêt",
                text: "Voulez-vous mettre à jour ce Type Prêt ",
                showCancelButton: true,
                confirmButtonText: "Oui",
                cancelButtonText: "Non",
                icon: "question"
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true);
                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdateTypepret,
                        headers: {
                            'CypherTypepret': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode == 200) {
                                    setIsSubmit(false);
                                    HandleAnnul();
                                    SweetAlert.fire({ title: "Succès", text: res.Message, icon: "success" });
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" });
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error);
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" });
                        });
                }
            });
        }

        if (sbmit == "supp") {
            SweetAlert.fire({
                title: "Suppression d'un Type Prêt",
                text: "Voulez-vous Supprimer ce Type Prêt ",
                showCancelButton: true,
                confirmButtonText: "Oui",
                cancelButtonText: "Non",
                icon: "question"
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true);
                    let data = Crypter.encrypt(JSON.stringify(Demand.TYPEPRET));
                    let config = {
                        method: 'delete',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.DeleteTypepret,
                        headers: {
                            'CypherTypepret': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode == 200) {
                                    setIsSubmit(false);
                                    HandleAnnul();
                                    SweetAlert.fire({ title: "Succès", text: res.Message, icon: "success" });
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" });
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error);
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" });
                        });
                }
            });
        }
    }

    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        });
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' });
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" });
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> Type de prêt </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                <Form
                    disabled={FormAct}
                    autoComplete="off"
                    layout="vertical"
                    labelAlign='left'
                    form={form}
                    name="dynamic_form_complex"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    onValuesChange={(changedValues) => {
                        if (changedValues?.DUREE !== undefined) {
                            loadTerme(changedValues.DUREE);
                        }
                    }}
                >
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult() }} type="ghost" htmlType="button" block>Consulter</Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block>Ajouter</Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block>Modifier</Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>Enregistrer</Button>
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>Supprimer</Button>
                                <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block>Actualiser</Button>
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>Annuler</Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div style={{width: '88%'}}>
                            <Tabs
                                onChange={e => { if (Activetabs == true) { consult() } }}
                                size='small'
                                type="card"
                                defaultActiveKey="1"
                                tabBarGutter={8}
                                tabBarStyle={{ overflowX: 'auto', whiteSpace: 'nowrap' }}
                                items={items}
                            />
                        </div>
                    </div>
                    {hiddenFields}
                </Form>
            </Spin>
        </div>
    );
}

export default Typepret;
